import LeaveRequestComponent from 'components/LeaveRequest';
import PermissionGuard from 'components/Global/PermissionGuard'; 

export const LeaveRequest = () => {
	return (
		<PermissionGuard permission="Allow_Leave_Request">
			<LeaveRequestComponent />
		</PermissionGuard>
	);
};
